import { z } from 'zod';

/**
 * Punkte-Konstanten für das Loyalitätssystem.
 * Punkte-Ledger: +10 Anwesenheit, +3 Frühbucher, -10 unentschuldigt, etc.
 */
export const LOYALTY_POINTS = {
  ATTENDANCE: 10,
  EARLY_BIRD: 3,
  NO_SHOW: -10,
} as const;

/**
 * Grund für ein Loyalitäts-Event Enum.
 */
export const LoyaltyReasonSchema = z.enum([
  'attendance',
  'early_bird',
  'no_show',
  'manual',
  'bonus',
]);

/** TypeScript Type für Loyalitäts-Grund */
export type LoyaltyReason = z.infer<typeof LoyaltyReasonSchema>;

/**
 * Zod Schema für LoyaltyEvent — Runtime-Validierung + Type-Inference.
 * Punkte-Ledger-Eintrag: positiv oder negativ.
 */
export const LoyaltyEventSchema = z.object({
  id: z.string().cuid(),
  userId: z.string(),
  eventId: z.string().cuid().nullable().optional(),
  points: z.number().int(),
  reason: LoyaltyReasonSchema,
  note: z.string().nullable().optional(),
  createdAt: z.coerce.date(),
});

/** TypeScript Type — abgeleitet aus dem Zod Schema */
export type LoyaltyEvent = z.infer<typeof LoyaltyEventSchema>;

/**
 * Schema für LoyaltyEvent-Erstellung.
 */
export const CreateLoyaltyEventSchema = LoyaltyEventSchema.pick({
  userId: true,
  eventId: true,
  points: true,
  reason: true,
  note: true,
});

/** TypeScript Type für LoyaltyEvent-Erstellung */
export type CreateLoyaltyEvent = z.infer<typeof CreateLoyaltyEventSchema>;

/**
 * Schema für LoyaltyEvent-Update.
 * Nur note ist nachträglich aktualisierbar (append-only Ledger).
 */
export const UpdateLoyaltyEventSchema = LoyaltyEventSchema.pick({
  note: true,
}).partial();

/** TypeScript Type für LoyaltyEvent-Update */
export type UpdateLoyaltyEvent = z.infer<typeof UpdateLoyaltyEventSchema>;
